import type { ImportPlatform } from './myGamesApi';

const STORAGE_KEY = 'endchess.pendingImport';

/** Fired when a new pending import is stored, so the poller can wake up. */
export const PENDING_IMPORT_ADDED_EVENT = 'endchess:pending-import-added';

export type PendingImport = {
  platform: ImportPlatform;
  username: string;
  priorCount: number;
  startedAt: number;
};

function isPendingImport(value: unknown): value is PendingImport {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const entry = value as Record<string, unknown>;
  return (
    (entry.platform === 'chesscom' || entry.platform === 'lichess') &&
    typeof entry.username === 'string' &&
    entry.username.length > 0 &&
    typeof entry.priorCount === 'number' &&
    Number.isFinite(entry.priorCount) &&
    typeof entry.startedAt === 'number' &&
    Number.isFinite(entry.startedAt)
  );
}

export function readPendingImport(): PendingImport | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as unknown;
    return isPendingImport(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function addPendingImport(entry: PendingImport): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
  window.dispatchEvent(new Event(PENDING_IMPORT_ADDED_EVENT));
}

export function clearPendingImport(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
